import actions from './actions'
import mutations from './mutations'

const state = {
  loading: false,
  warehouse: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
